export default __webpack_public_path__ + "vimeo.svg";